import {copilot, users} from '@cl/shared';
import {CLDispatch} from 'common/src/redux/store';
import {AgentName} from '../../copilot.enums';
import assistantPlaintextChatItem from '../../utils/creators/assistantPlaintextChatItem';
import {addChatItem, createChat as createChatAction} from '../copilot.slice';

function createChat() {
  return (dispatch: CLDispatch) => {
    // Create chat in shared memory
    const chat = copilot.createChat();
    const chatId = chat.id;

    // Create chat in Redux with the same ID
    dispatch(createChatAction({chatId}));

    // Add welcome message to the new chat
    const user = users.userSubject.data;
    const userFirstName = user?.firstName?.trim();
    const text = userFirstName
      ? `How can I help you today, ${userFirstName}?`
      : 'How can I help you today?';
    const chatItem = assistantPlaintextChatItem({agent: AgentName.General, content: text});
    dispatch(addChatItem({chatId, chatItem}));

    return chatId;
  };
}

export default createChat;
